import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-auto block p-4 border-gray-300"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-4 w-30" }, "Criterion"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, "Description")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "divide-y divide-gray-200"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "p-2 text-center font-mono" }
const _hoisted_6 = { class: "px-2 py-8 text-md whitespace-pre-wrap" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "p-2 text-center font-mono" }
const _hoisted_9 = { class: "p-2 text-md" }
const _hoisted_10 = {
  key: 1,
  class: "p-4 text-lg text-gray-300"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.criteria.length > 0)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _hoisted_2,
        (!_ctx.historical)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criteria, (criterion) => {
                return (_openBlock(), _createElementBlock("tr", {
                  onClick: ($event: any) => (_ctx.selectCriterion(criterion.name)),
                  class: _normalizeClass(_ctx.getRowStyles(criterion.name)),
                  key: criterion.name
                }, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(criterion.name), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString(criterion.detail), 1)
                ], 10, _hoisted_4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criteria, (criterion) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: criterion.name
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(criterion.name), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(criterion.detail), 1)
                ]))
              }), 128))
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, "No Other Criteria"))
}